import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getProjectGroup = api(async function getProjectGroup({ projectId, groupId }) {
    if (!projectId || !groupId) return null
    return query(
        gql`
            query GetProjectGroup($projectId: String!, $groupId: String!) {
                getProjectGroup(projectId: $projectId, groupId: $groupId) {
                    id
                    name
                    type
                    status
                    amends
                    legislation
                    error
                    readOnly
                    legacySendResults {
                        status
                        scheduleId
                    }
                    legislationData {
                        legacyId
                        title
                        redirectUrl
                    }
                    ... on AddGroup {
                        taskOwnershipTracked
                        addTypeSchedules {
                            id
                            code
                            title
                            seedSource
                            recordAmends
                        }
                        newTasks {
                            temporaryTaskId
                            isHeader
                            title
                            classification
                            content
                            note
                            componentRef
                            linkedFields
                            frequency {
                                period
                                interval
                                label
                            }
                            skillSet
                            minutes
                            unitOfMeasure
                        }
                    }
                    ... on LeadingSummaryGroup {
                        leadingSummaryTypeSchedules {
                            id
                            code
                            title
                        }
                        leadingSummary
                        overwriteExisting
                        leadingSummaryOwnershipTracked
                    }
                    ... on OverwriteGroup {
                        sourceTask
                        sourceTaskId
                        scheduleId
                        originalTaskId
                        originalTask {
                            id
                            isHeader
                            title
                            classification
                            content
                            note
                            taskId
                            componentRef
                            linkedFields
                            frequency {
                                period
                                interval
                                label
                            }
                            skillSet
                            skill {
                                _id
                                CoreSkillingID
                                SkillingCode
                                Skilling
                                Rate
                            }
                            minutes
                        }
                        similarTasks {
                            id
                            task {
                                id
                                isHeader
                                title
                                classification
                                content
                                taskId
                                note
                                componentRef
                                linkedFields
                                frequency {
                                    period
                                    interval
                                    label
                                }
                                skillSet
                                skill {
                                    CoreSkillingID
                                    SkillingCode
                                    Skilling
                                }
                                minutes
                            }
                            scheduleId
                            taskId
                            fullStrength
                            scheduleTitle
                            scheduleCode
                        }
                    }
                    ... on IntroductionGroup {
                        introTypeSchedules {
                            id
                            code
                            title
                            seedSource
                            recordAmends
                        }
                        intro
                        introductionOwnershipTracked
                    }
                }
            }
        `,
        { projectId, groupId },
        { returns: "getProjectGroup" }
    )
})
